import React from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import useCompanyAccess from "../hooks/useCompanyAccess";

export default function GuardLayout() {
	const { pathname } = useLocation();
	const { hasAccess } = useCompanyAccess();

	if (!hasAccess(pathname)) {
		return <Navigate to="/errors/404" replace />;
	}

	return <Outlet />;
}
